import React from "react";
import { Route, Routes } from "react-router-dom";
import AuthRoutes from "../routes/AuthRoutes";

const AuthLayout = () => {
    return (
        <div id="root">
            <div className={`main-content`}>
            <Routes>
                {AuthRoutes.map((prop) => (
                    <Route path={prop.path} element={prop.element} key={prop.path} />
                ))}
                <Route path="*" element={<div>Not Found Auth Layout Path</div>} />
            </Routes>
            </div>
        </div>
    );
};

export default AuthLayout;